import type { ReactNode } from "react";

export interface FilterBarProps {
  search?: ReactNode;
  filters?: ReactNode;
  activeCount?: number;
  onClear?: () => void;
  clearLabel?: string;
}

/** Search + compact filters on one row; shows Limpar only when something is active. */
export function FilterBar({
  search,
  filters,
  activeCount = 0,
  onClear,
  clearLabel = "Limpar filtros",
}: FilterBarProps) {
  return (
    <div className="ui-filterbar">
      {search ? <div className="ui-filterbar-search">{search}</div> : null}
      {filters}
      {activeCount > 0 && onClear ? (
        <button type="button" className="ui-filterbar-clear" onClick={onClear}>
          {clearLabel} ({activeCount})
        </button>
      ) : null}
    </div>
  );
}
